import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a4816798&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a4816798&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=a4816798&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4816798",
  null
  
)

export default component.exports